import { render } from "./AppConfig.vue?vue&type=template&id=10f4eb0d"
import script from "./AppConfig.vue?vue&type=script&lang=js"
export * from "./AppConfig.vue?vue&type=script&lang=js"
script.render = render

export default script